var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.09227 9.63386C8.59433 10.122 9.40968 10.122 9.91175 9.63386L17.6235 2.13533C18.1255 1.64714 18.1255 0.854325 17.6235 0.366139C17.1214 -0.122046 16.306 -0.122046 15.804 0.366139L9 6.98204L2.19603 0.370045C1.69396 -0.118141 0.878612 -0.118141 0.376548 0.370045C-0.125516 0.858231 -0.125516 1.65104 0.376548 2.13923L8.08825 9.63777L8.09227 9.63386Z",
    fill: "#32363D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.8413fb62b15a5fb322b692e437c442d8.svg";
export { ForwardRef as ReactComponent };